import {
  Button,
  Input,
  Stack,
  Box,
  Flex,
  useBreakpointValue,
  Heading,
  Field,
  Text,
  DownloadTrigger,
  useDisclosure,
} from "@chakra-ui/react";
import { useState, useEffect, useCallback } from "react";
import { editPdfFile } from "helpers/backend_helper";
import OnePDFDropzone from "./components/OnePdfDropzone";
import PDFViewer from "./components/PdfDocumentDisplay";
import UploadPdfModal from "./components/UploadPdfModal";
import LoadingOverlay from "components/LoadingScreen/LoadingOverlay";
const PdfTextReplacer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [editedPdfFile, setEditedPdfFile] = useState(null);
  const [editedPdfName, setEditedPdfName] = useState("edited.pdf");
  const [search, setSearch] = useState("");
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [error, setError] = useState("");
  const handleFileChange = useCallback((file) => {
    if (!file) {
      console.log("No file provided");
      return;
    }
    
    if (file.type === "application/pdf") {
      console.log("Valid PDF file selected:", file.name);
      setPdfFile(file); // ✅ store actual File
    } else {
      console.error("Invalid file type:", file.type);
      alert(`Invalid file. Please upload a PDF. File type received: ${file.type}`);
    }
  }, []);

  const handleEdit = async () => {
    if (!pdfFile || !search) return;

    try {
      setIsLoading(true);
      setError("");
      setEditedPdfFile("");
      const formData = new FormData();
      formData.append("file", pdfFile); // ✅ directly use File
      formData.append("search", search);

      const response = await editPdfFile(formData);
      const contentType = response.headers["content-type"];

      if (
        response.status !== 200 &&
        contentType &&
        contentType.includes("application/json")
      ) {
        const text = new TextDecoder().decode(response.data);
        const json = JSON.parse(text);
        setError(json.message);
        return;
      }

      const contentDisposition = response.headers["content-disposition"];

      let filename = "edited.pdf";
      if (contentDisposition && contentDisposition.includes("filename=")) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      setEditedPdfFile(url);
      setEditedPdfName(filename);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.error("Edit PDF error:", err);
    }
  };

  useEffect(() => {
    if (pdfFile) {
      setIsUploadOpen(false);
      setEditedPdfFile("");
    }
  }, [pdfFile]);

  return (
    <Flex height="120%" width="100%">
      <Box flex="1" height="100%" width="100%">
        <Flex
          height="100%"
          align="center"
          justify="center"
          direction={"column"}
        >
          <PDFViewer
            pdfFile={pdfFile}
            mode="original"
            search={search}
            setSearch={setSearch}
            setIsUploadOpen={setIsUploadOpen}
            handleEdit={handleEdit}
          />
        </Flex>
      </Box>
      <Box flex="1" height="100%" width="100%">
        <Flex
          height="100%"
          align="center"
          justify="center"
          direction={"column"}
        >
          <PDFViewer
            pdfFile={editedPdfFile}
            mode="final"
            search={search}
            editedPdfFile={editedPdfFile}
            editedPdfName={editedPdfName}
            error={error}
          />
        </Flex>
      </Box>
      {isUploadOpen && (
        <UploadPdfModal
          isOpen={isUploadOpen}
          setIsOpen={setIsUploadOpen}
          handleFileChange={handleFileChange}
        />
      )}
      {isLoading && <LoadingOverlay />}
    </Flex>
  );
};
export default PdfTextReplacer;


